import React from 'react';
import { Helmet } from 'react-helmet';

const Dpa: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>Acord de împuternicit (DPA)</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Acord de împuternicit (DPA) – șablon</h1>
        <p className="text-sm text-muted-foreground">Ultima actualizare: 11 februarie 2026</p>
      </div>

      <div className="rounded-lg border border-border bg-muted p-4 text-xs text-muted-foreground">
        Acest document este un șablon orientativ pentru implementări B2B. Trebuie adaptat și validat juridic înainte de
        utilizare (inclusiv anexele și măsurile tehnice/organizatorice).
      </div>

      <section className="rounded-lg border border-border bg-card p-4 text-sm space-y-2">
        <div className="font-semibold">Părțile</div>
        <div className="text-muted-foreground space-y-2">
          <div>
            <span className="text-foreground">Operator</span>: [Denumire școală / unitate de învățământ], [date firmă],
            reprezentată de [•], în calitate de [•].
          </div>
          <div>
            <span className="text-foreground">Împuternicit</span>: Global Linknet SRL, județul Argeș, Pitești, Str.
            Dorobanților, nr. 14, bl. 51, et. 1, ap. 8, J03/1287/2023, CUI 48291648, e-mail: office@globallinknet.ro.
          </div>
        </div>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">1. Obiect și durată</h2>
        <p>
          Prezentul acord („DPA”) reglementează prelucrarea datelor cu caracter personal de către Împuternicit în numele
          Operatorului, în legătură cu furnizarea Platformei <span className="text-foreground">Scola</span>.
        </p>
        <p>Durata: pe perioada contractului principal și cât timp Împuternicitul prelucrează date în numele Operatorului.</p>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">2. Natura, scopul și categoriile de date</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>administrarea conturilor (elev/profesor/părinte/admin), autentificare și roluri;</li>
          <li>gestionarea catalogului (note, absențe), orarului, temelor, materialelor;</li>
          <li>comunicare (mesaje, conversații), comunitate, resurse/bibliotecă;</li>
          <li>securitate, jurnalizare tehnică, prevenirea abuzurilor, suport și mentenanță.</li>
        </ul>
        <div className="space-y-2">
          <div className="font-semibold text-foreground">Persoane vizate</div>
          <p>Elevi (inclusiv minori), părinți/tutori, profesori, personal administrativ și alți utilizatori autorizați.</p>
        </div>
        <div className="space-y-2">
          <div className="font-semibold text-foreground">Tipuri de date</div>
          <p>
            Date de identificare și cont (nume, e-mail, rol, username), date educaționale (clase, note, absențe), comunicări
            (mesaje/fișiere), date tehnice (IP, loguri).
          </p>
        </div>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">3. Instrucțiuni și confidențialitate</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>Împuternicitul prelucrează datele doar pe baza instrucțiunilor documentate ale Operatorului.</li>
          <li>Împuternicitul se asigură că persoanele autorizate să prelucreze datele sunt ținute la confidențialitate.</li>
        </ul>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">4. Măsuri tehnice și organizatorice</h2>
        <p>
          Împuternicitul implementează măsuri rezonabile pentru a asigura confidențialitatea, integritatea și
          disponibilitatea datelor (ex.: control acces pe roluri, parole stocate hashed, limitări pentru încărcări fișiere,
          backup, monitorizare).
        </p>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">5. Subîmputerniciți</h2>
        <p>
          Operatorul poate aproba utilizarea subîmputerniciților (ex.: servicii de e-mail) în condițiile contractului și cu
          garanții adecvate. Lista subîmputerniciților poate fi menținută într-o anexă/în documentația contractuală.
        </p>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">6. Asistență pentru drepturi și incidente</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>Împuternicitul asistă Operatorul, în mod rezonabil, la solicitări privind drepturile persoanelor vizate.</li>
          <li>
            În caz de incident de securitate, Împuternicitul notifică Operatorul fără întârzieri nejustificate, conform
            contractului.
          </li>
        </ul>
      </section>

      <section className="space-y-3 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">7. Ștergere/returnare la încetare</h2>
        <p>
          La încetarea contractului, Împuternicitul va returna și/sau va șterge datele conform instrucțiunilor Operatorului,
          în limitele legale și tehnice (inclusiv existența unor copii de siguranță pentru o perioadă limitată).
        </p>
      </section>
    </div>
  );
};

export default Dpa;

